import React from 'react';
import { Stack } from 'braid-design-system';
import { Helmet } from 'react-helmet';
import getBrandSpecificTitle from 'src/utils/getBrandSpecificTitle';
import { useTypedSelector } from 'src/reducers';
import getBrandSpecificDescription from 'src/utils/getBrandSpecificDescription';
import ChangeEmailContainer from './ChangeEmail/ChangeEmailContainer';
import ChangePasswordContainer from './ChangePassword/ChangePasswordContainer';
import DeleteAccountContainer from './DeleteAccount/DeleteAccountContainer';
import { useMelwaysInfo } from '@seek/melways-react';

export const Account = () => {
  const site = useTypedSelector((store) => store.page.pageAnalytics.site);
  const { language } = useMelwaysInfo();

  return (
    <>
      <Helmet>
        <title>{getBrandSpecificTitle(site, language)}</title>
        <meta
          name="description"
          content={getBrandSpecificDescription(site, language)}
        />
      </Helmet>
      <Stack space="small">
        <ChangeEmailContainer />
        <ChangePasswordContainer />
        <DeleteAccountContainer />
      </Stack>
    </>
  );
};
